<template>
  <div class="modal confirmation-modal">
    <div class="confirmation-modal__panel">
      <div class="modal__main-icon modal__main-icon--reset-password"></div>
      <div class="confirmation-modal__body">
        Are you sure you want to Reset The User Password?
      </div>
      <div class="confirmation-modal__footer">
        <button type="button" class="confirmation-modal__button confirmation-modal__button--cancel"
          @click="store.commit('setShowResetPasswordModal', false)">
          Cancel
        </button>
        <div v-if="isRequesting"
          class="button button--default button--loading confirmation-modal__button confirmation-modal__button--submit">
        </div>
        <button v-else @click="resetPassword()" type="button"
          class="button button--default confirmation-modal__button confirmation-modal__button--submit">
          Yes
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

defineOptions({
  name: "ResetPasswordModal"
});

const store = useStore();
const route = useRoute();

const isRequesting = ref(false);
const userId = computed(() => Number(route.params.id));
const canResetUserPassword = computed(() => {
  if (store.getters.isSuperAdmin) return true;

  if (!userId.value || Number.isNaN(userId.value)) {
    return false;
  }

  const targetUser = store.getters.user;
  const teamIds = Array.isArray(targetUser?.teams)
    ? targetUser.teams.map((team) => Number(team.id)).filter((id) => Number.isInteger(id) && id > 0)
    : [];

  if (!teamIds.length) {
    return false;
  }

  return store.getters.canPerformActionOnEntity("user_edit", teamIds);
});

const resetPassword = async () => {
  if (!canResetUserPassword.value) {
    store.commit("setShowResetPasswordModal", false);
    return;
  }

  try {
    isRequesting.value = true;

    const {
      data: { message },
    } = await store.dispatch("resetUserPassword", route.params.id);

    store.commit("setToast", {
      display: true,
      type: "success",
      message,
    });

    isRequesting.value = false;
    store.commit("setShowResetPasswordModal", false);
  } catch (error) {
    isRequesting.value = false;
    console.error("Failed to reset password:", error);
  }
};
</script>

<style scoped lang="scss"></style>
